import React from 'react';
import { Link } from 'react-router-dom';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <Link to="/" className="inline-block mb-8">
            <img
              src="/HRO-Logo-transparent-white-logo.png"
              alt="Horse Racing Oracle"
              className="h-12"
            />
          </Link>
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Refund Policy
          </h1>
        </div>

        {/* Content */}
        <div className="bg-white shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:p-6 space-y-8">
            {/* 14-Day Refund Section */}
            <div>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                14-Day Money Back Guarantee
              </h2>
              <p className="text-gray-600">
                If for any reason you are unhappy with the service, you can have a full refund within 14 days of signing up. 
                Contact us and your refund will be processed within 1 day.
              </p>
            </div>

            {/* Trial Section */}
            <div>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                7-Day Trial Period
              </h2>
              <p className="text-gray-600">
                7 day free trial - You can cancel at any time during the 7 day trial period with nothing else to pay. 
                This must be done DURING the 7 day trial & not afterwards. Contact us and your cancellation will be 
                processed within 1 day.
              </p>
            </div>

            {/* Fair Use Policy Section */}
            <div>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Fair Use Policy
              </h2>
              <ul className="list-disc pl-5 text-gray-600 space-y-2">
                <li>
                  New Horse Racing Oracle customers only are entitled to ONE refund or trial.
                </li>
                <li>
                  If you've had a subscription to Horse Racing Oracle previously that lapsed then you won't be 
                  entitled to a refund if you rejoin.
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div className="bg-gray-50 rounded-lg p-6 mt-8">
              <h2 className="text-lg font-medium text-gray-900 mb-4">
                Need to Request a Refund?
              </h2>
              <p className="text-gray-600 mb-4">
                Please contact our support team and we'll process your request within 1 business day.
              </p>
              <Link
                to="/contact"
                className="btn btn-primary inline-flex items-center"
              >
                Contact Support
                <svg
                  className="ml-2 -mr-1 h-4 w-4"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 